import Sidebar from "./views/sections/sidebar";
import "./styles/main.css";
import Client from "./Client";
import SameDayLGU from "./views/pages/tabs/forms/sameday/LGU";
import { MainRouter, Tabs } from "./routes";
import { Routes, Route, useNavigate, BrowserRouter } from "react-router-dom";


function App() {
  return (<BrowserRouter>
    <MainRoutes />
  </BrowserRouter>);
}

function MainRoutes() {
  Client.initialize();
  Tabs.initialize();
  MainRouter.navigate = useNavigate();

  const routeOptions = MainRouter.listRoutes();

  return (
      <Routes>
        {routeOptions.map((o, i) => {
            const path = o[0];
            const route = o[1];
            const View = route.view;
            return (<Route key={`route-${i}`} exact path={path} element={<View />} />);
        })} 
      </Routes>
  );
}

export function Entry() {
  
  setTimeout(() => {
    if(Client.signedIn) {
      Tabs.initialize();
      MainRouter.goto("/dashboard/sameday")
    } else MainRouter.goto("/login")
  }, 10);
  return <div />;
}

function Window() {
  return (
    <div className="window">
      <Sidebar />
      <Main />
    </div>
  );
}

function Main() {
  return (<main>
    <SameDayLGU />
  </main>)
}


export default App;
